/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
jQuery(document).ready(function ($) {

    /**
     * 
     * PAGINA RICERCA ANNUNCIO
     * 
     * 
     *  
     */
    // abilita pulsante ricerca
    $("#button-ricerca-annuncio").prop("disabled", false);
    
    $('#ricerca-annuncio-good-crossing-point').change(function () {

        if (this.value !== '')
            $('#ricerca-annuncio-localizzazione').val('');
    });
    $('#ricerca-annuncio-localizzazione').change(function () {

        if (this.value !== '')
            $('#ricerca-annuncio-good-crossing-point').val('');
    });
    $(document).on("click", ".button-prenota-annuncio", function () {

        $('#messagePrenotaAnnuncio').html('');
        $("#messagePrenotaAnnuncio").removeClass('alert-danger');
        $("#messagePrenotaAnnuncio").removeClass('alert-success');
        $("#messagePrenotaAnnuncio").hide();
        var id_annuncio = this.value;
        var faiAjax = true;
        if (faiAjax)
        {
            var r = confirm("Sei sicuro di volere prenotare questo annuncio?");

            if (r == true) {
                themeSpinner('show');
                $.ajax({//create an ajax request to load_page.php
                    type: "POST",
                    cache: false,
                    url: ajax_url,
                    data:
                            {
                                action: 'prenota_annuncio_action',
                                id_annuncio: id_annuncio

                            },
                    dataType: "html", //expect html to be returned                
                    success: function (response) {
                        if (response === '1')
                        {
                            $("#messagePrenotaAnnuncio").html('Annuncio Prenotato');
                            $("#messagePrenotaAnnuncio").addClass('alert-success');
                            $("#messagePrenotaAnnuncio").show();
                            $(".button-prenota-annuncio").hide();
                            $(".button-elimina-prenotazione-annuncio").show();
                        }
                        else
                        {
                            $("#messagePrenotaAnnuncio").html(response);
                            $("#messagePrenotaAnnuncio").addClass('alert-danger');
                            $("#messagePrenotaAnnuncio").show();
                        }
                        themeSpinner('hide');

                    },
                    error: function () {
                        themeSpinner('hide');
                        $("#messagePrenotaAnnuncio").html('Problemi nella prenotazione dell\' annuncio');
                        $("#messagePrenotaAnnuncio").addClass('alert-danger');
                        $("#messagePrenotaAnnuncio").show();
                    }

                });
            }
        }
    });
    
    $(document).on('click','.button-visualizza-annuncio',function () {
        window.location.href = this.value;
    });
    $(document).on('click', '.button-visualizza-oggetto', function () {
        window.location.href = this.value;
    });
    $("#button-ricerca-annuncio").click(function () {
        ricercaAnnuncio(1);
    });
    $("#form-ricerca-annuncio").submit(function () {
        ricercaAnnuncio(1);
        return false;
    });
    
    
    $(document).on("click", ".button-elimina-prenotazione-annuncio", function () {
        $('#messagePrenotaAnnuncio').html('');
        $("#messagePrenotaAnnuncio").removeClass('alert-danger');
        $("#messagePrenotaAnnuncio").removeClass('alert-success');
        $("#messagePrenotaAnnuncio").hide();
        var id_annuncio = this.value;
        var faiAjax = true;
        if (faiAjax)
        {
            var r = confirm("Sei sicuro di volere elimnare la prenotazione a questo annuncio?");
            if (r == true) {
                themeSpinner('show');
                $.ajax({//create an ajax request to load_page.php
                    type: "POST",
                    cache: false,
                    url: ajax_url,
                    data:
                            {
                                action: 'elimina_prenotazione_annuncio_action',
                                id_annuncio: id_annuncio

                            },
                    dataType: "html", //expect html to be returned                
                    success: function (response) {
                        if (response === '1')
                        {
                            $("#messagePrenotaAnnuncio").html('La prenotazione è stata cancellata');
                            $("#messagePrenotaAnnuncio").addClass('alert-success');
                            $("#messagePrenotaAnnuncio").show();
                            $(".button-prenota-annuncio").show();
                            $(".button-elimina-prenotazione-annuncio").hide();
                        }
                        else
                        {
                            $("#messagePrenotaAnnuncio").html(response);
                            $("#messagePrenotaAnnuncio").addClass('alert-danger');
                            $("#messagePrenotaAnnuncio").show();
                        }
                        themeSpinner('hide');


                    },
                    error: function () {
                        themeSpinner('hide');
                        $("#messagePrenotaAnnuncio").html('Problemi nell\'eliminazione della prenotazione dell\' annuncio');
                        $("#messagePrenotaAnnuncio").addClass('alert-danger');
                        $("#messagePrenotaAnnuncio").show();
                    }

                });
            }
        }
    });
    $(document).on('click', '.pageNumbers', function (e)
    {
                if(e.target.id!='puntini')
                    ricercaAnnuncio(e.target.id);
    });

});

$("#button-resetta-filtri").click(function () {
        resettaFiltri();
    });
function resettaFiltri()
{
        $('#ricerca-annuncio-condizioni').val('');
        $('#ricerca-annuncio-taglia').val('');
        $('#ricerca-annuncio-good-crossing-point').val('');
        $('#ricerca-annuncio-localizzazione').val('');
        $('#ricerca-annuncio-nome').val('');
        $('#ricerca-annuncio-categoria').val('');
        $("#tutti-tipologia-annuncio").prop("checked", true);
        creaTestoFiltriSelezionati();
        ricercaAnnuncio(1);
}

function creaTestoFiltriSelezionati()
{
        var reg_condizioni = $('#ricerca-annuncio-condizioni option:selected').text();
        var reg_taglia = $('#ricerca-annuncio-taglia option:selected').text();
        var reg_good_crossing_point = $('#ricerca-annuncio-good-crossing-point option:selected').text();
        var reg_localizzazione = $('#ricerca-annuncio-localizzazione option:selected').text();
        var reg_categoria = $('#ricerca-annuncio-categoria option:selected').text();
        var reg_tipologia = $("input[name='ricerca-annuncio-tipologia']:checked").val() === undefined ? '' : $("input[name='ricerca-annuncio-tipologia']:checked").val();
        var html_filtri='';

        html_filtri=html_filtri+  "<strong>tipologia annuncio:</strong> "+ $("input[name='ricerca-annuncio-tipologia']:checked").parent().text();
        if(reg_categoria!='-')
            html_filtri=html_filtri+  ", <strong>categoria oggetto:</strong> "+ reg_categoria;
        if(reg_taglia!='-')
            html_filtri=html_filtri+  ", <strong>fascia d'età:</strong> "+ reg_taglia;
        if(reg_condizioni!='-')
            html_filtri=html_filtri+  ", <strong>condizioni oggetto:</strong> "+ reg_condizioni;
        if(reg_localizzazione!='-')
            html_filtri=html_filtri+  ", <strong>zona ritiro:</strong> "+ reg_localizzazione;
        if(reg_good_crossing_point!='-')
            html_filtri=html_filtri+  ", <strong>punto ToornaQui:</strong> "+ reg_good_crossing_point;
        $('#lista-filtri-attivi').html(html_filtri);
}
function ricercaAnnuncio(num_page, success)
    {
        $('#risultato-ricerca-annuncio-div').html('');
        $("#messageSearchOffer").html('');
        $("#messageSearchOffer").removeClass('alert-info');
        $("#messageSearchOffer").removeClass('alert-danger');
        $("#messageSearchOffer").hide();
        $("#messagePrenotaAnnuncio").html('');
        $("#messagePrenotaAnnuncio").removeClass('alert-info');
        $("#messagePrenotaAnnuncio").removeClass('alert-danger');
        $("#messagePrenotaAnnuncio").hide();

        var reg_condizioni = $('#ricerca-annuncio-condizioni').val();
        var reg_taglia = $('#ricerca-annuncio-taglia').val();
        var reg_good_crossing_point = $('#ricerca-annuncio-good-crossing-point').val();
        var reg_localizzazione = $('#ricerca-annuncio-localizzazione').val();
        var reg_titolo = $('#ricerca-annuncio-nome').val();
        var reg_categoria = $('#ricerca-annuncio-categoria').val();
        var reg_tipologia = $("input[name='ricerca-annuncio-tipologia']:checked").val() === undefined ? '' : $("input[name='ricerca-annuncio-tipologia']:checked").val();
        
        
        form = new FormData();
        // carico ilform tramit formdata per upload del file

        form.append('condizioni', reg_condizioni);
        form.append('good_crossing_point', reg_good_crossing_point);
        form.append('localizzazione', reg_localizzazione);
        form.append('titolo', reg_titolo);
        form.append('categoria', reg_categoria);
        form.append('taglia', reg_taglia);
        form.append('tipologia_annuncio', reg_tipologia);
        form.append('action', 'ricerca_annuncio_action');
        form.append('numpage', num_page);
//        window.localStorage.setItem('ricercaTitolo',reg_titolo);
//        window.localStorage.setItem('ricercaCondizioni',reg_condizioni);
//        window.localStorage.setItem('ricercaGCP',reg_good_crossing_point);
//        window.localStorage.setItem('ricercaCategoria',reg_categoria);
//        window.localStorage.setItem('ricercaLocalizzazione',reg_localizzazione);
//        window.localStorage.setItem('ricercaTipologia',reg_tipologia);
//        window.localStorage.setItem('ricercaTaglia',reg_taglia);
        localStorage.setItem('ricercaPagina',num_page == null ? 1 : num_page);
        
    
        themeSpinner('show');
        $.ajax({//create an ajax request to load_page.php
            type: "POST",
            data: form,
            mimeType: 'multipart/form-data',
            contentType: false,
            cache: false,
            processData: false,
            dataType: "html",
            url: ajax_url,
            success: function (resp) {
                creaTestoFiltriSelezionati();
                if(typeof(success) == "function"){
                    themeSpinner('hide');
                    success(resp);
                }
                else{
                    themeSpinner('hide');
                    $('#risultato-ricerca-annuncio-div').html(resp);
                    $(".result-message").show();
                    $(document).scrollTop($("#risultato-ricerca-annuncio-div").offset().top);
                }
            },
            error: function () {
                themeSpinner('hide');
                $("#messageSearchOffer").html('Problemi nella ricerca dell\'annuncio');
                $("#messageSearchOffer").addClass('alert-danger');
                $("#messageSearchOffer").show();
            }

        });
    }

